import { pdfjs } from 'react-pdf';

/**
 * WARNING! THIS CONFIG SHOULD BE OUR ENTRYPOINT FOR PDFJS
 * - DON'T import pdfjs diretly from 'react-pdf'
 *   `import { pdfjs } from 'react-pdf'`
 * - DON'T use any pdfjs from dependecies
 *   `import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'`
 */

/**
 * We load pdf.js styles from cloudfare too (check public/index.html)
 * react-pdf/dist/esm/Page/AnnotationLayer.css does not provide all css fixes
 *
 * react-pdf@5.7.2 enforces pdfjs-dist@2.12.313
 * If we try changing pdfjs versions it throws an error:
 * > The API version "XXX" does not match the Worker version "XXX"
 *
 * An alternative path is loading the pdfjs worker as part of the bundle,
 * but on CRA 4 (webpack 4) we can only load up to 2.6.347. Newer pdfjs
 * versions will throw build errors due to es6 compatibility issues.
 *
 * We use the local pdfjs depedency for developing purposes (typescript)
 * It is never loaded on the client side because we use the `workerSrc` prop
 */
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

// Re-export PDFjs from react-pdf library
export default pdfjs;
